module.exports = __webpack_public_path__ + "slide5.d700838068e2f906183d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/private/home/slide5.jpg
// module id = ./src/assets/images/private/home/slide5.jpg
// module chunks = main